import React from 'react'
import PropTypes from 'prop-types'

import './styles.scss'

const Video = ({ youTubeVideoId, videoURL, placeholderImg }) => {
  const src = `https://www.youtube-nocookie.com/embed/${youTubeVideoId}?modestbranding=1&autoplay=false&controls=0&fs=0&loop=1&rel=0`

  const youTube = (
    <object
      title="Daniel Rahman"
      className="play-video__frame"
      data={src}
      frameBorder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    />
  )
  const linkToVideo = (
    <>
      <a href={videoURL} target="_blank" rel="noopener noreferrer">
        <div className="mtv-link">
          <img
            className="mtv-link--size"
            src={placeholderImg}
            alt="Link to video from MTV"
          />
        </div>
        <svg
          className="mtv-link__icon"
          width="69"
          height="69"
          viewBox="0 0 69 69"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 34.5C0 15.4755 15.4755 0 34.5 0C53.5245 0 69 15.4755 69 34.5C69 53.5245 53.5245 69 34.5 69C15.4755 69 0 53.5245 0 34.5ZM51 35L25 20V50L51 35Z"
          />
        </svg>
      </a>
    </>
  )
  // Render youTube video or placeholder image
  let result
  if (youTubeVideoId) {
    result = youTube
    return result
  }
  result = linkToVideo

  return <div className="play-video">{result}</div>
}

Video.propTypes = {
  youTubeVideoId: PropTypes.string,
  videoURL: PropTypes.string,
  placeholderImg: PropTypes.string,
}

Video.defaultProps = {
  youTubeVideoId: '',
  videoURL: '',
}

Video.defaultProps = {
  placeholderImg: '',
}

export default Video
